import { render } from "./NidFormView.vue?vue&type=template&id=621be1c2"
import script from "./NidFormView.vue?vue&type=script&lang=js"
export * from "./NidFormView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__